import { meshComponent } from './Mesh.js';
import { props, createGeometry } from '../geometries/RingGeometry.js';

export default meshComponent('Ring', props, createGeometry);
